import { FC } from 'react';
import { ActionModal, ModalTypes } from '@monorepo/controlled/src/components/modal/modals/action-modal/action-modal';
import { IModalInjectProps } from '@monorepo/controlled/src/components/modal/modal/modal';

interface IStopLinkModal extends IModalInjectProps {
	onConfirm: () => void;
}

export const StopLinkModal: FC<Partial<IStopLinkModal>> = ({ onConfirm, closeModal, id }) => {
	return (
		<ActionModal type={ModalTypes.Warning} primaryBtnTitle={'Stop Link'} onAction={onConfirm} closeModal={closeModal} id={id ?? 0}>
			<div>
				<p>Stopping this link will disable it for now.</p>
				<p>
					<strong>You can enroll it again later.</strong>
				</p>
			</div>
		</ActionModal>
	);
};
